<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a category') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="category">{{ _('Category') }}</label><br />
            <v-select :options="categories" v-model="category" label="name" keys="['id', 'name']" :placeholder="_('Type to search categories')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search categories') }}</template>
              </template>
            </v-select>
          </div>
          <div class="form-group" v-if="allowSelectAll">
            <label>
              <input type="checkbox" v-model="selectAll" /> {{ _('Add all categories') }}
            </label>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <div class="flex-row space-between">
        <button class="btn btn-success" v-on:click="selectCategory"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
        <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i><span class="hidden-xs">  {{ _('Close') }}</span></button>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  props: ['selectedCategories', 'allowSelectAll'],
  mixins: [constants],
  data () {
    return {
      category: null,
      categories: [],
      selectAll: false
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedCategoryIds () {
      return this.selectedCategories.map(l => l.id)
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectCategory () {
      if (this.selectAll) {
        this.$emit('selectCategory', this.categories)
      } else {
        this.$emit('selectCategory', this.category)
      }
    },
    async loadCategories() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/categories.json?iSortingCols=1&iSortCol_0=2&sSortDir_0=asc&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.categories = response.data.filter(category => {
        return this.selectedCategoryIds.indexOf(category.id) === -1 // Only list products that are not already added
      }).sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
  },
  mounted () {
    this.loadCategories()
  }
}
</script>